import React from 'react';
import { Link } from 'react-router-dom';

/**
 * HOW IT WORKS. Two steps and a footnote, because that is genuinely the whole
 * process: they send a website, we send back a redesign of it.
 *
 * Anything longer than this reads as a process to get through rather than an
 * easy thing to do, and the ask is the only part that has to land.
 */

const STEPS = [
  {
    n: '01',
    title: 'You send us your website',
    body: 'Just the address. Nothing else to fill in, nothing to prepare.',
  },
  {
    n: '02',
    title: 'We send you a redesign of it',
    body: 'Designed from a blank page, built and live so you can open it on your phone. Not a mockup.',
  },
];

export default function HowItWorks() {
  return (
    <section className="al-section bg-[#0A1A2F] text-[#F8F4EC]">
      <div className="al-container">
        <div className="al-eyebrow text-[#C5A059]"><span aria-hidden />How it works</div>

        <h2 className="mt-9 max-w-[16ch] font-serif text-[clamp(2.3rem,5.5vw,4.4rem)] leading-[1.02] tracking-[-0.03em]">
          Send us the site. <em className="font-normal text-[#C5A059]">We send back the redesign.</em>
        </h2>

        <ol className="mt-14 grid gap-px overflow-hidden rounded-[20px] sm:mt-16 md:grid-cols-2" style={{ background: 'rgba(255,255,255,0.12)' }}>
          {STEPS.map((step) => (
            <li key={step.n} className="p-7 sm:p-10" style={{ background: '#0A1A2F' }}>
              <div className="font-mono-label text-[12px] text-[#C5A059]">{step.n}</div>
              <h3 className="mt-5 font-serif text-[clamp(1.4rem,2.6vw,1.9rem)] leading-tight">{step.title}</h3>
              <p className="mt-4 text-[16px] leading-[1.55] sm:text-[17px]" style={{ color: 'rgba(248,244,236,0.7)' }}>
                {step.body}
              </p>
            </li>
          ))}
        </ol>

        <p className="mt-12 max-w-[52ch] border-l border-[#C5A059] pl-5 text-[16px] leading-[1.6] text-[#F8F4EC]/[0.72] sm:text-[17px]">
          If you like it, we finish it and put it live on your domain. If you do not, you have lost
          nothing. There is nothing to commit to either way.
        </p>

        <div className="mt-12">
          <Link
            to="/contact"
            className="group inline-flex w-full items-center justify-center rounded-sm bg-[#C5A059] px-10 py-5 text-center text-[13px] font-semibold uppercase tracking-[0.18em] text-[#0A1A2F] transition-colors duration-300 hover:bg-[#F8F4EC] sm:w-auto"
          >
            <span>Send us your site</span>
            <span aria-hidden className="ml-3 transition-transform duration-300 group-hover:translate-x-1">→</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
